var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCopyPaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-copy-paste",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14470",
    "data-name": "Caminho 14470",
    d: "M14.769,22.846H5.077A2.077,2.077,0,0,1,3,20.769V11.077A2.077,2.077,0,0,1,5.077,9h9.692a2.077,2.077,0,0,1,2.077,2.077v9.692A2.077,2.077,0,0,1,14.769,22.846ZM5.077,10.385a.692.692,0,0,0-.692.692v9.692a.692.692,0,0,0,.692.692h9.692a.692.692,0,0,0,.692-.692V11.077a.692.692,0,0,0-.692-.692Z",
    transform: "translate(-3 -4.846)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14471",
    "data-name": "Caminho 14471",
    d: "M9.692,6.462A.692.692,0,0,1,9,5.769V5.077A2.077,2.077,0,0,1,11.077,3h.692a.692.692,0,0,1,0,1.385h-.692a.692.692,0,0,0-.692.692v.692A.692.692,0,0,1,9.692,6.462Z",
    transform: "translate(-4.846 -3)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14472",
    "data-name": "Caminho 14472",
    d: "M25.385,21.462h-.692a.692.692,0,0,1,0-1.385h.692a.692.692,0,0,0,.692-.692v-.692a.692.692,0,1,1,1.385,0v.692A2.077,2.077,0,0,1,25.385,21.462Z",
    transform: "translate(-9.462 -7.615)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14473",
    "data-name": "Caminho 14473",
    d: "M26.769,6.462a.692.692,0,0,1-.692-.692V5.077a.692.692,0,0,0-.692-.692h-.692a.692.692,0,1,1,0-1.385h.692a2.077,2.077,0,0,1,2.077,2.077v.692A.692.692,0,0,1,26.769,6.462Z",
    transform: "translate(-9.462 -3)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14474",
    "data-name": "Caminho 14474",
    d: "M27.692,14.154A.692.692,0,0,1,27,13.462V10.692a.692.692,0,1,1,1.385,0v2.769A.692.692,0,0,1,27.692,14.154Z",
    transform: "translate(-10.385 -5.154)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_14475",
    "data-name": "Caminho 14475",
    d: "M19.462,4.385H16.692a.692.692,0,1,1,0-1.385h2.769a.692.692,0,1,1,0,1.385Z",
    transform: "translate(-7 -3)",
    fill: "#1c787e",
    stroke: "#1c787e",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCopyPaste);
export default __webpack_public_path__ + "static/media/ico-copy-paste.0a3c473993ec71f16a88f9118107cb9d.svg";
export { ForwardRef as ReactComponent };